import React, { useEffect, useState } from "react";
import { Button, Col, Form, Spinner, Container, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { getBooking, getProfitByBooking } from "./MarqueeDetails.actions";
import Select from "react-select";
import { isEmpty } from "lodash";
import Swal from "sweetalert";
import MaterialTable from "material-table";
import jsPDF from "jspdf";
import moment from "moment";
import logo from "../../../../../Images/logo.png";

const ProfitByBooking = (props) => {
  const [bookingId, setBookingId] = useState("");
  console.log(bookingId, bookingId);
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

  const handleVisible = () => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: "Added successfully...",
      icon: "success",
      button: "Ok",
    });
  };

  const handleDangerVisible = () => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: "Something went wrong...",
      icon: "error",
      button: "Ok",
    });
  };

  const handleChangeBookingById = (selectedOption) => {
    console.log(selectedOption, "sop");
    setBookingId(selectedOption.value);
    // setBookingName(selectedOption.label);
    // props.getBookingById(selectedOption.value)
  };

  const getBookingList =
    !isEmpty(props.bookingList) &&
    props.bookingList.map((x) => {
      let data = { value: x.booking_id, label: x.booking_name };
      return data;
    });
  const exportPDF = () => {
    props.getProfitByBooking(bookingId);
  };

  useEffect(() => {
    props.getBooking();
  }, []);

  return (
    <>
      {props.isFetchingBookingData ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Form>
              <Row>
                <Col lg="12" md="12" xs="12">
                  <Form.Group className="mb-3" controlId="garana">
                    <Form.Label>
                      <b>Select booking *</b>
                    </Form.Label>
                    <Select
                      isDisabled={isEmpty(props.bookingList)}
                      placeholder="Select booking..."
                      onChange={handleChangeBookingById}
                      options={getBookingList}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
            <div className="sendDiv" style={{ marginTop: "15px" }}>
              {bookingId == "" ? (
                <Button
                  className="sendButton"
                  disabled
                  style={{ backgroundColor: "black" }}
                  onClick={() => exportPDF()}
                >
                  Generate
                </Button>
              ) : (
                <Button className="sendButton" onClick={() => exportPDF()}>
                  Generate
                </Button>
              )}
            </div>
            <div>
              <MaterialTable
                title="Profit By Booking"
                columns={[
                  { title: "Total Cost", field: "total_cost" },
                  { title: "Total Expense", field: "total_expense" },
                  { title: "Total Profit", field: "total_profit" },
                ]}
                data={[props.profitByID]}
                options={{
                  actionsColumnIndex: -1,
                  filtering: false,
                  exportButton: true,
                  paging: true,
                  pageSize: 5, // make initial page size
                  emptyRowsWhenPaging: false, // To avoid of having empty rows
                  pageSizeOptions: [50, 100, 150, 200],
                  exportPdf: (columns, data) => {
                    const doc = new jsPDF();

                    const columnTitles = columns.map(
                      (columnDef) => columnDef.title
                    );

                    const pdfData = data.map((rowData) =>
                      columns.map(
                        (columnDef) => (
                          console.log(rowData[columnDef.field], "eeeee"),
                          columnDef.field == "createdAt"
                            ? moment(rowData[columnDef.field]).format(
                                "YYYY-MM-DD"
                              )
                            : rowData[columnDef.field]
                        )
                      )
                    );
                    let content = {
                      startY: 50,
                      startX: 5,
                      head: [columnTitles],
                      body: pdfData,
                    };
                    const companyName = `${process.env.REACT_APP_COMPANY_NAME}`;
                    const companyAddress = `${process.env.REACT_APP_COMPANY_ADDRESS}`;
                    const companyNTN = `STRN#${process.env.REACT_APP_COMPANY_NTN}`;

                    doc.addImage(logo, "PNG", 10, 11, 30, 30);
                    // doc.text(`Company Name: ${companyName}`, 75, 20, 0, 20);

                    doc.setFont("Times New Roman", "bolditalic");
                    // doc.setFontT("bolditalic");
                    doc.text(companyName, 75, 15, 0, 20);
                    doc.setFontSize(9);
                    doc.setFont("Times New Roman", "normal");
                    doc.text(companyAddress, 75, 20, 0, 20);
                    doc.text(companyNTN, 75, 25, 0, 20);
                    doc.setFontSize(14);
                    doc.setFont("Times New Roman", "normal");
                    doc.text("Datewise Sale Report", 75, 46, 0, 20);
                    doc.autoTable(content);

                    doc.save(`ByIdProfitReport.pdf`);
                  },
                  headerStyle: {
                    position: "sticky",
                    top: 0,
                    color: "#00BBBB",
                    fontWeight: "550",
                    onRowAdd: "none",
                  },
                }}
              />
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    //     addExpense: (data, handleVisible, handleDangerVisible) => dispatch(addExpense(data, handleVisible, handleDangerVisible)),
    //     getExpense: (id) => dispatch(getExpense(id)),
    //     getMasterControl: (id) => dispatch(getMasterControl(id)),
    //    // UpdateHRExpense: (newData, oldData) => dispatch(UpdateHRExpense(newData, oldData)),
    //     deleteExpense: (menu_id) => dispatch(deleteExpense(menu_id)),
    //     SearchMarqueeExpenseReport:(id)=>dispatch(SearchMarqueeExpenseReport(id)),
    //     getBookingById:(id) => dispatch(getBookingById(id)),
    getBooking: () => dispatch(getBooking()),
    getProfitByBooking: (bookingId) => dispatch(getProfitByBooking(bookingId)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  // departmentList: state.MarqueeReducer.departmentList,
  // isFetchingExpenseData: state.MarqueeReducer.isFetchingExpenseData,
  // isAddingExpenseData: state.MarqueeReducer.isAddingExpenseData,
  // expenseList: state.MarqueeReducer.expenseList,
  // masterControlsList: state.MarqueeReducer.masterControlsList,
  bookingList: state.MarqueeReducer.bookingList,
  isFetchingprofitByID: state.MarqueeReducer.isFetchingprofitByID,
  profitByID: state.MarqueeReducer.profitByID,
  isFetchingBookingData: state.MarqueeReducer.isFetchingBookingData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfitByBooking);
